<template>
  <div class="banner">
    <div class="banner-img">
      <el-image :src="img" fit="cover" />
    </div>
    <div class="banner-title">
      <p>{{ title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    title: {
      type: String,
      default: "",
    },
    img: {
      type: String,
      default: "/images/news.png",
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 300px;
  display: flex;
  position: relative;
  overflow: hidden;
  background-color: #fff;

  .banner-img {
    width: 100%;
    height: 100%;
    /deep/ .el-image {
      height: 100%;
    }
  }

  &-title {
    position: absolute;
    color: #fff;
    font-size: 45px;
    font-weight: 400;
    line-height: 300px;
    text-align: center;
    width: 100%;
  }
}
</style>
